<div class="client-review" *ngIf="count > 0">
  <!-- Needs-review cue -->
  <button type="button" class="client-review__cue" (click)="toggle()">
    <span class="client-review__cue-text">
      <span class="client-review__cue-title">{{ count }} possible {{ count === 1 ? 'client' : 'clients' }}</span>
      <span class="client-review__cue-sub">Tap to select the right one</span>
    </span>
    <span class="client-review__badge">
      REVIEW
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" [class.client-review__chev--up]="open"><path d="m6 9 6 6 6-6"/></svg>
    </span>
  </button>

  <!-- Candidate picker -->
  <ng-container *ngIf="open">
    <div class="client-review__backdrop" (click)="close()"></div>
    <div class="client-review__menu">
      <div class="client-review__menu-head">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.94 14.06A2 2 0 0 0 8.5 12.62l-5.6-1.45a.5.5 0 0 1 0-.96l5.6-1.45a2 2 0 0 0 1.44-1.44l1.45-5.6a.5.5 0 0 1 .96 0l1.45 5.6a2 2 0 0 0 1.44 1.44l5.6 1.45a.5.5 0 0 1 0 .96l-5.6 1.45a2 2 0 0 0-1.44 1.44l-1.45 5.6a.5.5 0 0 1-.96 0z"/></svg>
        <span>Possible clients</span>
      </div>
      <button type="button" class="client-review__item" *ngFor="let c of candidates; trackBy: trackByCandidateId"
        [disabled]="saving" (click)="confirm(c)">
        <span class="client-review__item-text">
          <span class="client-review__item-name">{{ c.clientName }}</span>
          <span class="client-review__item-sub" *ngIf="c.companyName">{{ c.companyName }}</span>
          <span class="client-review__item-sub" *ngIf="!c.companyName">{{ c.entityType === 2 ? 'Company' : 'Contact' }}</span>
        </span>
      </button>
      <p class="client-review__error" *ngIf="errorMessage">{{ errorMessage }}</p>
    </div>
  </ng-container>
</div>
